import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {CriteriaWeightPipe} from '../criteria-weight.pipe';
import {toggleCriterionId} from '../criteria-weights-overview.utils';
import {CriteriaWeightsCriterion} from '../step-4-3-criteria-weights-overview.types';
import {CriteriaWeightsTableRow} from './criteria-weights-table.types';

@Component({
  selector: 'app-criteria-weights-table',
  imports: [TranslocoPipe, TranslateDirectusPipe, CriteriaWeightPipe],
  templateUrl: './criteria-weights-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CriteriaWeightsTableComponent {
  readonly criteria = input.required<CriteriaWeightsCriterion[]>();
  readonly testId = input.required<string>();

  private readonly expandedCriteriaIds = signal<ReadonlySet<number>>(new Set());

  protected readonly rows = computed<CriteriaWeightsTableRow[]>(() => {
    const expandedCriteriaIds = this.expandedCriteriaIds();

    return this.criteria().map((criterion) => {
      const expanded = expandedCriteriaIds.has(criterion.id);

      return {
        criterion,
        expanded,
        toggleIcon: expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right',
      };
    });
  });

  toggleCriterion(criterionId: number): void {
    this.expandedCriteriaIds.update((expandedIds) => toggleCriterionId(expandedIds, criterionId));
  }
}
